/* Videos ALMADA (17 sep 2026): banner de video y carrusel de videos comprables.
   Custom elements: se reinician solos cuando el editor del tema vuelve a dibujar la sección. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var isMobile = function () { return window.matchMedia('(max-width: 640px)').matches; };

  function setPlayingState(root, playing) { root.classList.toggle('is-paused', !playing); }
  function setSoundState(root, muted) { root.classList.toggle('is-unmuted', !muted); }

  // Celulares y Safari leen HLS directo: la calidad se adapta a la conexión.
  // Solo en celular: en computador se usa el MP4, que todos los navegadores leen seguro.
  var probe = document.createElement('video');
  var canHls = !!probe.canPlayType && probe.canPlayType('application/vnd.apple.mpegurl') !== '';
  function pickSource(hls, mp4) { return (canHls && hls && isMobile()) ? hls : mp4; }

  // Si el formato adaptativo falla en algún navegador, se cambia solo al MP4.
  function withFallback(video, mp4) {
    if (!mp4 || video.dataset.fallbackReady) return;
    video.dataset.fallbackReady = '1';
    video.addEventListener('error', function () {
      if (video.getAttribute('src') !== mp4) { video.src = mp4; safePlay(video); }
    });
  }

  function safePlay(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* ---------------- Banner de video ---------------- */
  if (!customElements.get('almada-video-banner')) {
    customElements.define('almada-video-banner', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.video = this.querySelector('.AVB__Video');
        if (!this.video) return;
        this.userPaused = reduceMotion || saveData;
        setPlayingState(this, !this.userPaused);

        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              self.load();
              if (!self.userPaused) safePlay(self.video);
            } else {
              self.video.pause();
            }
          });
        }, { rootMargin: '200px 0px' });
        this.observer.observe(this);

        this.video.addEventListener('playing', function () { self.classList.add('is-ready'); });

        var playBtn = this.querySelector('[data-avb-toggle-play]');
        if (playBtn) playBtn.addEventListener('click', function () {
          self.load();
          if (self.video.paused) { self.userPaused = false; safePlay(self.video); }
          else { self.userPaused = true; self.video.pause(); }
          setPlayingState(self, !self.userPaused);
          playBtn.setAttribute('aria-label', self.userPaused ? 'Reproducir video' : 'Pausar video');
        });

        var soundBtn = this.querySelector('[data-avb-toggle-sound]');
        if (soundBtn) soundBtn.addEventListener('click', function () {
          self.video.muted = !self.video.muted;
          setSoundState(self, self.video.muted);
          soundBtn.setAttribute('aria-label', self.video.muted ? 'Activar sonido' : 'Silenciar');
          if (!self.video.muted && self.video.paused) { self.userPaused = false; self.load(); safePlay(self.video); setPlayingState(self, true); }
        });
      }

      load() {
        if (this.loaded) return;
        var mobile = isMobile();
        var src = mobile
          ? pickSource(this.dataset.hlsMobile || this.dataset.hlsDesktop, this.dataset.srcMobile || this.dataset.srcDesktop)
          : pickSource(this.dataset.hlsDesktop, this.dataset.srcDesktop);
        if (!src) return;
        withFallback(this.video, mobile ? (this.dataset.srcMobile || this.dataset.srcDesktop) : this.dataset.srcDesktop);
        this.video.src = src;
        this.loaded = true;
      }

      disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    });
  }

  /* ---------------- Carrusel de videos comprables ---------------- */
  if (!customElements.get('almada-video-carousel')) {
    customElements.define('almada-video-carousel', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('[data-avc-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-avc-slide]'));
        if (!this.track || !this.slides.length) return;

        this.muted = true;
        this.userPaused = reduceMotion || saveData;
        this.visible = false;
        this.active = -1;

        // Centrar el primero al cargar (en computador se ven varios a los lados)
        setTimeout(function () { self.updateActive(true); }, 0);

        var ticking = false;
        this.track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          setTimeout(function () { ticking = false; self.updateActive(); }, 80);
        }, { passive: true });

        this.querySelector('[data-avc-prev]').addEventListener('click', function () { self.goTo(self.active - 1); });
        this.querySelector('[data-avc-next]').addEventListener('click', function () { self.goTo(self.active + 1); });

        this.slides.forEach(function (slide, i) {
          var media = slide.querySelector('.AVC__Media');
          var video = slide.querySelector('video');

          media.addEventListener('click', function (e) {
            if (e.target.closest('button')) return;
            if (i !== self.active) { self.goTo(i); return; }
            self.togglePlay();
          });

          if (video) {
            var bar = slide.querySelector('[data-avc-progress]');
            video.addEventListener('timeupdate', function () {
              if (bar && video.duration) bar.style.transform = 'scaleX(' + (video.currentTime / video.duration) + ')';
            });
            video.addEventListener('playing', function () { slide.classList.add('is-ready'); });
          }

          var playBtn = slide.querySelector('[data-avc-toggle-play]');
          if (playBtn) playBtn.addEventListener('click', function () {
            if (i !== self.active) { self.goTo(i); return; }
            self.togglePlay();
          });

          var soundBtn = slide.querySelector('[data-avc-toggle-sound]');
          if (soundBtn) soundBtn.addEventListener('click', function () {
            if (i !== self.active) self.goTo(i);
            self.muted = !self.muted;
            if (!self.muted) self.userPaused = false;
            self.applyState();
          });

          var igBtn = slide.querySelector('[data-avc-ig]');
          if (igBtn) igBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (i !== self.active) self.goTo(i);
            self.openInstagram(igBtn.getAttribute('data-avc-ig'), igBtn.getAttribute('data-avc-ig-link'));
          });

          Array.prototype.forEach.call(slide.querySelectorAll('[data-avc-add]'), function (btn) {
            btn.addEventListener('click', function () { self.addToCart(btn); });
          });
        });

        this.observer = new IntersectionObserver(function (entries) {
          self.visible = entries[0].isIntersecting;
          self.applyState();
        }, { threshold: 0.35 });
        this.observer.observe(this.track);
      }

      disconnectedCallback() { if (this.observer) this.observer.disconnect(); }

      updateActive(initial) {
        var trackRect = this.track.getBoundingClientRect();
        var center = trackRect.left + trackRect.width / 2;
        var best = 0, bestDist = Infinity;
        this.slides.forEach(function (slide, i) {
          var r = slide.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        if (initial && this.slides.length > 2 && !isMobile()) {
          best = Math.floor((this.slides.length - 1) / 2);
          this.goTo(best, true);
        }
        if (best !== this.active) {
          this.active = best;
          this.applyState();
        }
      }

      goTo(index, instant) {
        if (index < 0) index = this.slides.length - 1;
        if (index >= this.slides.length) index = 0;
        var slide = this.slides[index];
        var left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
        if (instant) {
          this.track.style.scrollBehavior = 'auto';
          this.track.scrollLeft = left;
          this.track.style.scrollBehavior = '';
          this.active = index;
          this.applyState();
        } else {
          this.track.scrollTo({ left: left, behavior: 'smooth' });
        }
      }

      togglePlay() {
        this.userPaused = !this.userPaused;
        this.applyState();
      }

      applyState() {
        var self = this;
        this.slides.forEach(function (slide, i) {
          var isActive = i === self.active;
          var video = slide.querySelector('video');
          slide.classList.toggle('is-active', isActive);
          setSoundState(slide, !isActive || self.muted);
          setPlayingState(slide, isActive && !self.userPaused);
          if (!video) return;

          if (isActive && self.visible && !self.userPaused) {
            if (!video.getAttribute('src') && (video.dataset.src || video.dataset.hls)) {
              withFallback(video, video.dataset.src);
              video.src = pickSource(video.dataset.hls, video.dataset.src);
            }
            video.muted = self.muted;
            safePlay(video);
          } else {
            video.pause();
            video.muted = true;
          }
        });
      }

      openInstagram(embedUrl, link) {
        var self = this;
        var modal = this.querySelector('[data-avc-modal]');
        if (!modal) { window.open(link, '_blank', 'noopener'); return; }
        var body = modal.querySelector('[data-avc-modal-body]');
        var out = modal.querySelector('[data-avc-modal-link]');

        // Se pausa el carrusel mientras la ventana está abierta
        this.userPaused = true;
        this.applyState();

        out.href = link || embedUrl;
        body.innerHTML = '<div class="AVC__ModalLoading">Cargando…</div>';
        var frame = document.createElement('iframe');
        frame.src = embedUrl;
        frame.loading = 'lazy';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.allowFullscreen = true;
        frame.title = 'Video de Instagram';
        frame.addEventListener('load', function () {
          var loading = body.querySelector('.AVC__ModalLoading');
          if (loading) loading.remove();
        });
        body.appendChild(frame);

        if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');

        var close = function () {
          body.innerHTML = '';
          if (typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open');
          self.userPaused = false;
          self.applyState();
        };
        modal.querySelector('[data-avc-modal-close]').onclick = close;
        modal.onclick = function (e) { if (e.target === modal) close(); };
        modal.onclose = function () { body.innerHTML = ''; self.userPaused = false; self.applyState(); };
      }

      addToCart(btn) {
        var label = btn.textContent;
        btn.disabled = true;
        btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-avc-add'), 10), quantity: 1 }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('No se pudo agregar');
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = '✓';
          document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1 } }));
          setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; }, 1800);
        }).catch(function () {
          btn.classList.remove('is-loading');
          btn.textContent = label;
          btn.disabled = false;
        });
      }
    });
  }
})();
